import { type FeaturedChartProps } from '@src/components/FeaturedChart/FeaturedChart.props'

const defaultBlocksBottom = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        component: {
          name: 'Text',
          options: {
            text: '<p>*Plant-Based</p><p>Competitive data collected January 2024 for the following brands and flavors:</p><p>Vega: myvega.com/products/vega-one-organic • Orgain orgain.com/products/organic-protein-superfoods-plant-based-protein-powder • KalChava: kachava.com/collections/all</p><p>VitaHustle ONE: vitahustle.com/products/vitahustle-one-superfood • Isagenix: isagenix.com/en-US/shop/weight-management/whole-blend-plant-based-isalean-shake KaChava is a trademark of Tribal Nutrition LLC.</p><p>Vita Hustle One is a trademark of Hustle Hart, LLC. Isagenix is a trademark of Isagenix Worldwide, LLC. Vega is a trademark of Sequel Naturals ULC. Orgain is a trademark of Orgain, LLC.</p>',
            style: 'Body XS',
          },
        },
        responsiveStyles: {
          large: { color: 'rgba(160, 158, 163, 1)', fontWeight: '400', marginTop: '8px' },
        },
      },
    ],
    responsiveStyles: {
      large: {
        paddingBottom: '0px',
        gap: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      },
    },
  },
] as any

export const defaultRowBlocks = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        component: {
          name: 'Text',
          options: { text: '<p>Amount per serving</p>', style: 'Body MD - Medium weight' },
        },
        responsiveStyles: { large: { color: 'rgba(255, 255, 255, 1)', fontSize: '12px' } },
      },
    ],
    responsiveStyles: { large: { display: 'flex', flexDirection: 'row' } },
  },
] as any

export const FeaturedChartDefaults = {
  heading: 'If you’re not drinking Shakeology, you’re missing out',
  featuredColumnHeader: 'Shakeology',
  blocksBottom: defaultBlocksBottom,
  rowHeadings: [
    { text: '<p>Vega One</p> <p>All-in-One</p>' },
    { text: '<p>Orgain</p> <p>50 Superfoods</p>' },
    { text: 'Ka’Chava' },
    { text: '<p>VitaHustle</p> <p>ONE</p>' },
    { text: '<p>Isagenix</p> <p>IsaLean</p>' },
  ],
  rows: [
    {
      blocks: defaultRowBlocks,
      content: [
        {
          icon: 'checkmark',
        },
        {
          icon: 'checkmark',
        },
        {
          icon: 'checkmark',
        },
        {
          icon: 'checkmark',
        },
        {
          icon: 'checkmark',
        },
      ],
    },
    {
      blocks: defaultRowBlocks,
      content: [
        {
          icon: 'checkmark',
        },
        {
          icon: 'checkmark',
        },
        {
          icon: 'checkmark',
        },
        {
          icon: 'x',
        },
        {
          icon: 'checkmark',
        },
      ],
    },
    {
      blocks: defaultRowBlocks,
      content: [
        {
          icon: 'checkmark',
        },
        {
          icon: 'x',
        },
        {
          icon: 'x',
        },
        {
          icon: 'checkmark',
        },
        {
          icon: 'x',
        },
      ],
    },
    {
      blocks: defaultRowBlocks,
      content: [
        {
          icon: 'x',
        },
        {
          icon: 'x',
        },
        {
          icon: 'checkmark',
        },
        {
          icon: 'x',
        },
        {
          icon: 'checkmark',
        },
      ],
    },
    {
      blocks: defaultRowBlocks,
      content: [
        {
          icon: 'x',
        },
        {
          icon: 'x',
        },
        {
          icon: 'checkmark',
        },
        {
          icon: 'checkmark',
        },
        {
          icon: 'checkmark',
        },
      ],
    },
    {
      blocks: defaultRowBlocks,
      content: [
        {
          icon: 'x',
        },
        {
          icon: 'dash',
        },
        {
          icon: 'checkmark',
        },
        {
          icon: 'x',
        },
        {
          icon: 'checkmark',
        },
      ],
    },
    {
      blocks: defaultRowBlocks,
      content: [
        {
          icon: 'checkmark',
        },
        {
          icon: 'x',
        },
        {
          icon: 'x',
        },
        {
          icon: 'dash',
        },
        {
          icon: 'x',
        },
      ],
    },
    {
      blocks: defaultRowBlocks,
      content: [
        {
          icon: 'x',
        },
        {
          icon: 'x',
        },
        {
          icon: 'x',
        },
        {
          icon: 'x',
        },
        {
          icon: 'checkmark',
        },
      ],
    },
    {
      blocks: defaultRowBlocks,
      content: [
        {
          icon: 'checkmark',
        },
        {
          icon: 'checkmark',
        },
        {
          icon: 'x',
        },
        {
          icon: 'x',
        },
        {
          icon: 'checkmark',
        },
      ],
    },
  ],
} satisfies FeaturedChartProps
